module.exports = __webpack_public_path__ + "assets/media/1.cb9667f3.wav";